import { rankWith, uiTypeIs, LayoutProps } from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { getLabel } from "../../../../../utils/DynamicForms";

import "./style.scss";

type Props = LayoutProps; // use correct prop type

const TextLayout = (props: Props) => {
  return (
    <div className="tru-layout-text">
      <div>{getLabel(props.uischema)}</div>
    </div>
  );
};

export const TextLayoutEntry = {
  tester: rankWith(1, uiTypeIs("TextLayout")),
  renderer: withJsonFormsLayoutProps(TextLayout),
};
